<i18n src="@/locales/models/producer.yml" lang="yaml"></i18n>

<template>
  <div class="panel">
    <div class="panel-header">
      <h3 class="panel-header-title">Datos del productor</h3>
    </div>

    <div class="panel-body">
      <div class="space-y-8 divide-y divide-slate-200">
        <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
          <div class="sm:col-span-3">
            <dt class="label-data">
              {{ $t("model.producer.organization_producer.producer_code") }}
            </dt>
            <dd class="content-data">
              {{ producer.organization_producer.producer_code }}
              <yes-no-label :value="producer.organization_producer.active" yes="Activo" no="Inactivo" />
            </dd>
          </div>
          <div class="sm:col-span-3">
            <dt class="label-data">
              {{ $t("model.producer.producer_code") }}
            </dt>
            <dd class="content-data">
              {{ producer?.producer_code }}
            </dd>
          </div>
          <div class="sm:col-span-3">
            <dt class="label-data">
              {{ $t("model.producer.lastname") }}
            </dt>
            <dd class="content-data">
              {{ producer.lastname }}
            </dd>
          </div>

          <div class="sm:col-span-3">
            <dt class="label-data">
              {{ $t("model.producer.name") }}
            </dt>
            <dd class="content-data">
              {{ producer?.name }}
            </dd>
          </div>

          <div class="sm:col-span-3">
            <dt class="label-data">
              {{ $t("model.producer.gender_id") }}
            </dt>
            <dd class="content-data">
              {{ genderName(producer.gender_id) }}
            </dd>
          </div>

          <div class="sm:col-span-3">
            <dt class="label-data">
              {{ $t("model.producer.producer_crops") }}
            </dt>
            <dd class="content-data">
              {{ producer_crops }}
            </dd>
          </div>

          <div
            v-for="(attribute_producer, index) in attribute_producers"
            :key="index"
            class="sm:col-span-3"
          >
            <dt class="label-data">
              {{ attribute_producer.label }}
            </dt>
            <dd class="content-data">
              <yes-no-label
                v-if="isBoolean(attribute_producer.datatype_id)"
                :value="
                  Boolean(Number(producerAttributeValue(attribute_producer.id)))
                "
              >
              </yes-no-label>
              <span v-if="isString(attribute_producer.datatype_id)">
                {{ producerAttributeValue(attribute_producer.id) }}
              </span>
            </dd>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GenderMixin from "@/components/views/mixins/organization/genders.js";
import DatatypeMixin from "@/components/views/mixins/organization/datatypes.js";
import Requester from "@/views/organization/requesters/partners/producers/manage_producer.js";

export default {
  name: "ProducerInfo",
  mixins: [GenderMixin, DatatypeMixin],
  data() {
    return {
      attribute_producers: []
    };
  },
  props: {
    producer: { required: true },
    organization_id: { required: true }
  },
  computed: {
    producer_crops: function () {
      return (this.producer.producer_crops || [])
        .map(producer_crop => producer_crop.crop.name)
        .join(", ");
    }
  },
  methods: {
    fetchAttributeProducers: async function () {
      let response = await Requester.fetchAttributeProducers(
        this.organization_id
      );

      this.attribute_producers = response.data;
    },
    producerAttributeValue: function (attribute_producer_id) {
      return this.producer.producer_attributes.find(
        pa => pa.attribute_producer_id == attribute_producer_id
      )?.value;
    }
  },
  created() {
    this.fetchAttributeProducers();
  }
};
</script>
